import script from "./CustomDropdownComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomDropdownComponent.vue?vue&type=script&setup=true&lang=ts"

import "./CustomDropdownComponent.vue?vue&type=style&index=0&id=6a4353ca&lang=css"

const __exports__ = script;

export default __exports__